/* eslint-disable max-len */
import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Rating } from '@material-ui/lab';
import AppBar from '@material-ui/core/AppBar';
import { List, ListItem, Typography, Tabs, Tab, Grid, Box, Drawer, Icon } from '@material-ui/core';
import { Block, DirectionsRun, FlashOn, Close } from '@material-ui/icons';

import store from '../../../store';
import commonStyles from '../../styles';
import UserListSelectBoxSp from './sp/userListSelectBoxSp';
import PullRefComponent from '../../common/pullRefComponent';
import MemberStatusIcon from '../../common/memberStatusIcon';
import LoadingEllipsis from '../../common/pullRefComponent/parts/loadingEllipsis';
import DetailSearch from '../../search/detailSearch';
import getListFromAllCustomer, {
  getDivisionFromCustomerTree,
  getUserFromCustomerTree,
} from '../../common/customerTree/commonFunc/getListFromAllCustomer';
import { useCustomerMain } from '../../../containers/customerMain/customerMainContext';
import { updateObjSearchItems } from '../../../store/search/searchItemsSlice';
import { sortCustomerList } from '../../../commonFunction/getSortAssociativeArray';
import judgeMemberStatus from '../../../commonFunction/judgeMemberStatus';
import { useQuery } from '../../../hooks';

import {
  CUSTOMER_STATUS_PURSUING,
  CUSTOMER_STATUS_NOT_PURSUING,
  CUSTOMER_STATUS_CONTRACT,
  CUSTOMER_STATUS_CLAIM,
} from '../../../constants';
import { mainHeadMenuTabsList } from '../../../constants/customerMain';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    '& .MuiPaper-root': {
      boxShadow: 'none',
    },
  },
  name: {
    display: 'flex',
    color: '#333',
    width: '100%',
  },
  name1: {
    fontSize: 20,
    fontWeight: '700',
    lineHeight: 1.6,
    marginRight: 8,
  },
  name2: {
    fontSize: 13,
    lineHeight: 1,
    letterSpacing: 0,
    textAlign: 'left',
    marginBottom: 2,
    display: 'inline-flex',
    alignItems: 'center',
  },
  title4: {
    wordBreak: 'keep-all',
    marginRight: 4,
  },
  title5: {
    fontSize: 13,
    fontWeight: 400,
    lineHeight: 1.6,
  },
  appBar: {
    top: '52px',
    borderBottom: '1px solid rgba(51, 51, 51, 0.04)',
    background: 'transparent',
    position: 'sticky',
  },
  tabs: {
    background: '#fff',
    color: '#333',
    fontFamily: 'Roboto',
    fontSize: 13,
    lineHeight: 1.6,
    letterSpacing: 0,
    '& .MuiTabs-flexContainer': {
      justifyContent: 'space-between',
    },
    '& .MuiTab-root': {
      minWidth: 'auto',
      padding: 8,
      color: '#333',
      fontSize: 13,
      lineHeight: 1,
      letterSpacing: 0,
      opacity: '1',
      flex: 1,
    },
    '& .MuiTab-root.Mui-selected': {
      color: theme.palette.primaryColor,
      fontWeight: '700',
    },
    '& .MuiTabs-indicator': {
      background: theme.palette.primaryColor,
    },
  },
  tabPanel: {
    width: '100%',
    '& > div': {
      height: '100%',
    },
    '& > div > div': {
      height: '100%',
    },
    '& .ptr': {
      height: 'auto',
    },
    '& .ptr__pull-down': {
      top: 0,
    },
    // '& > div > div > div': {
    //   height: '100%',
    // },
  },
  list: {
    paddingBottom: 60,
    background: '#fff',
  },
  scrollRoot: {
    // height: 'calc(100vh - 56px)',
    // height: `calc(100vh - ${56 + 49 + 58}px)`,
    height: 'calc(100vh - 162px)',
    background: '#fff',
    overflowY: 'auto',
    '.customerSelect + &': { height: 'calc(100vh - 226px)' },
    '.onlyAlert + .allWrapper &': { height: `calc(100vh - ${26 + 56 + 49 + 58}px)` },
    '.onlyAlert + .allWrapper .customerSelect + &': { height: `calc(100vh - ${26 + 56 + 49 + 58 + 39}px)` },
  },
  statusIcon: {
    fontSize: 20,
    marginBottom: 4,
  },
  statusIconWrap: {
    color: theme.palette.primaryColor,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    marginRight: 14,
    '& p': { writingMode: 'vertical-lr' },
    '&.following': {
      color: theme.palette.primaryColor,
    },
    '&.noFollowing': {
      color: '#D83420',
    },
    '&.contracted': {
      color: '#27AE60',
    },
    '&.claim': {
      color: '#D83420',
    },
  },
  memberStatusWrap: {
    display: 'flex',
    alignItems: 'center',
    '& > svg': {
      flexShrink: 0,
      marginRight: 4,
    },
  },
  wrapper: { display: 'flex', borderBottom: '1px solid rgba(51,51,51,0.1)' },
  grid: {
    width: 'calc(50% - 21.5px)',
    alignItems: 'center',
    display: 'flex',
    '& + &': {
      marginLeft: 43,
    },
  },
  starLbl: {
    color: '#FCE034',
    marginRight: 8,
    '& label:not(:last-of-type)': {
      marginRight: 2,
    },
    '& .MuiRating-icon svg': {
      stroke: '#333',
      fontSize: 10,
    },
  },
  userStatus: {
    marginLeft: 5,
  },
  noData: {
    paddingTop: '50px',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

function ItemWrap(props) {
  const { type, user, onClick } = props;
  const classes = useStyles();
  const common = commonStyles();

  const getIcon = (val) => {
    switch (Number(val)) {
      case CUSTOMER_STATUS_PURSUING:
        return (
          <Grid className={`${classes.statusIconWrap} following`}>
            <DirectionsRun className={classes.statusIcon} />
            <Typography className={common.title5}>追客中</Typography>
          </Grid>
        );
      case CUSTOMER_STATUS_NOT_PURSUING:
        return (
          <Grid className={`${classes.statusIconWrap} noFollowing`}>
            <Block className={classes.statusIcon} />
            <Typography className={common.title5}>追わない</Typography>
          </Grid>
        );
      case CUSTOMER_STATUS_CONTRACT:
        return (
          <Grid className={`${classes.statusIconWrap} contracted`}>
            <Icon className={classes.statusIcon}>verified</Icon>
            <Typography className={common.title5}>契約済み</Typography>
          </Grid>
        );
      case CUSTOMER_STATUS_CLAIM:
        return (
          <Grid className={`${classes.statusIconWrap} claim`}>
            <FlashOn className={classes.statusIcon} />
            <Typography className={common.title5}>クレーム</Typography>
          </Grid>
        );
      default:
        return (
          <Grid>
            <Typography className={common.title5}>該当なし</Typography>
          </Grid>
        );
    }
  };

  const getMemberStatus = (val) => {
    return (
      <Grid className={`${classes.memberStatusWrap}`}>
        <MemberStatusIcon code={val} />
        <Typography className={common.title5}>{judgeMemberStatus(val)}</Typography>
      </Grid>
    );
  };
  return (
    <ListItem
      className={classes.wrapper}
      onClick={onClick}
    >
      {getIcon(type === 'all' ? user.customerStatusCode : user.customerStatus)}
      <Grid container flexdirection="column">
        <Grid className={classes.name}>
          {type === 'all' ? (
            <Typography className={classes.name1}>
              {user.customerName}
            </Typography>
          ) : (
            <>
              {user.customerLastName && (
                <Typography className={classes.name1}>
                  {user.customerLastName}
                </Typography>
              )}
              {user.customerFirstName && (
                <Typography className={classes.name1}>
                  {user.customerFirstName}
                </Typography>
              )}
            </>
          )}
          <Typography className={classes.name2}>
            様
          </Typography>
        </Grid>
        <Grid container alignItems="center">
          <Grid className={classes.grid}>
            <Rating
              readOnly
              value={user.userLevel}
              className={classes.starLbl}
              size="small"
              name="size-large"
            />
            {getMemberStatus(type === 'all' ? user.memberStatusCode : user.webMemberStatus)}
          </Grid>
          <Grid className={`${classes.grid}`}>
            <Typography
              className={`${common.verySmallStrong} ${classes.title4}`}
            >
              担当&nbsp;
            </Typography>
            <Typography className={`${common.title5} ${classes.title5}`}>
              {type === 'all'
                ? `${[user.responsibleUserLastName, user.responsibleUserFirstName].filter(Boolean).join(' ')}`
                : `${[user.userLastName, user.userFirstName].filter(Boolean).join(' ')}`}
            </Typography>
          </Grid>
        </Grid>
        <Grid container alignItems="center">
          <Grid className={classes.grid}>
            <Typography className={`${common.verySmallStrong} ${classes.title4}`}>
              反響日&nbsp;
            </Typography>
            <Typography className={`${common.title5} ${classes.title5}`}>
              {type === 'all' ? user.effectAt.substr(0, 10) : user.effectAt.substr(0, 10) }
            </Typography>
          </Grid>
          <Grid className={classes.grid}>
            <Typography
              className={`${common.verySmallStrong} ${classes.title4}`}
            >
              最終対応&nbsp;
            </Typography>
            <Typography className={`${common.title5} ${classes.title5}`}>
              {type === 'all' ? (
                <span>{user.lastActivityAt ? user.lastActivityAt.substr(0, 10) : '-'}</span>
              ) : (
                <span>{user.lastActivityAt ? user.lastActivityAt.substr(0, 10) : '-'}</span>
              ) }
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </ListItem>
  );
}

function TabPanel(props) {
  const { children, value, index, userList, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Grid>{children}</Grid>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

/**
 * オブジェクトの空値(null, [], '')削除
 * @param {object} data
 * @returns object
 */
function removeEmptyItem(data) {
  const result = {};
  let value;
  Object.keys(data).forEach((key) => {
    value = data[key];
    if (Array.isArray(value)) {
      if (value.length) result[key] = value;
    } else if (value || value === 0) {
      result[key] = value;
    }
  });
  return result;
}

export default function MainHeadMenuTabs(props) {
  const {
    onClose2,
    getCustomerTreeResponseFunction,
    getBrowsingHistoryFunction,
  } = props;

  const {
    initLoginData,
    searchHeader,
    setSearchHeader,
    selectCustomer,
    setSelectCustomer,
    functions,
  } = useCustomerMain();

  // リロード要の検索条件を設定
  const searchParams = useSelector((state) => state.searchItems.searchParams);
  useEffect(() => {
    const copyObjParams = Object.assign({}, searchParams);
    const params = removeEmptyItem({ ...copyObjParams });
    setSearchHeader(params);
  }, [searchParams]);

  // パラメータからcustomerIdを取得
  const queryCustomerId = useQuery('customerId');

  // 閲覧顧客：初期ロード～データ表示までの流れ
  // 1. 初期ロード時にuseEfffectでgetBrowsingHistoryFunctionを叩く
  // 2. getBrowsingHistoryFunction内でglobalのstoreに格納
  // 3. customerBrowsedがuseSelectorでデータを取得
  // 4. useEffectでcustomerBrowsedが更新されたタイミングでcustomerBrowsedArrが更新される
  // その他：下スクロールでの追加取得の場合はfetchCount1に依存しているuseEffectを確認

  const classes = useStyles();
  const common = commonStyles();
  const dispatch = useDispatch();
  const element = useRef(null); // スクロール要素
  const scrollTimeoutRef = useRef(null);
  const browsedScrollTimeoutRef = useRef(null);
  const menusKeys = Object.keys(mainHeadMenuTabsList.menus);
  // 反響ツリー 顧客情報 取得
  const divisionsGetResponseTree = useSelector(
    (state) => state.divisionsGetResponseTree.divisionsGetResponseTree,
  );
  // 閲覧顧客情報 取得
  const customersBrowsed = useSelector(state => state.customerGetBrowsingHistory);
  const [initSearchHeader, setInitSearchHeader] = useState(false); // searchHeader初期化用
  const [fetchCount0, setFetchCount0] = useState(0); // 読み込みした回数
  const [fetchCount1, setFetchCount1] = useState(0);
  const [isLoadingActive, setIsLoadingActive] = useState(false); // ローディング状態
  const [open2, setOpen2] = useState(false); // 詳細検索画面の入れ込み
  const [tabSwitch, setTabSwitch] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const [customersBrowsedArr, setCustomersBrowsedArr] = useState({ customers: [] });
  // 顧客リストの取得、更新で以下使用
  const [allCustomer, setAllCustomer] = useState({});
  // FIXME: 詳細へ遷移させるため、初期設定ではuserIdを空とする。リリース時は上記コメントアウトに変更。
  // 反響ツリー選択ユーザー
  const [selectDefaultUser, setSelectDefaultUser] = useState({
    userId: 0, userName: '',
  });
  // 反響ツリー選択組織
  const [selectDefaultDivision, setSelectDefaultDivision] = useState({ divId: 0, divisionName: '-' });

  // ログイン情報
  console.log('ログイン情報', initLoginData);

  const handleChange = (event, newValue) => {
    console.log('handleChange------', newValue);
    setTabSwitch(newValue);
  };

  // 更新処理 (onRefresh)
  const handleRefresh = useCallback(async () => {
    setRefreshing(true);
    try {
      if (tabSwitch === 0) {
        setFetchCount0(0);
        const resData = await getCustomerTreeResponseFunction(searchHeader, true);
        const customers = getListFromAllCustomer(resData);
        // リロード時に顧客リストを更新する
        if (customers) {
          // displayOrderCodeが未設定の場合は初期値の0（反響日の新しい順）でソートする
          const orderCode = 'displayOrderCode' in searchHeader
            ? String(searchHeader.displayOrderCode)
            : '0';
          setAllCustomer(sortCustomerList(orderCode, customers));
        }
      }
      if (tabSwitch === 1) {
        setFetchCount1(0);
        getBrowsingHistoryFunction({ limit: 10, offset: 0 }); // customer015 10件取得
      }
      // TODO: offsetが0からになるので、下スクロールでoffsetを積んでいたところを0にリフレッシュ
      setRefreshing(false);
    } catch (err) {
      console.error(err);
    }
  }, [refreshing, tabSwitch, searchHeader]);

  // 担当者選択を解除した時の処理
  const handleClearFunction = () => {
    console.log('clear');
    setSelectDefaultUser({
      userId: initLoginData.userId,
      userName: initLoginData.userName,
    });
  };

  // コンテンツのスクロール量を検知し、下スクロールで更新カウントを取得
  const handleScroll = () => {
    const elH = element.current.clientHeight;
    const maxScroll = element.current.scrollHeight;
    const scrollTopVal = element.current.scrollTop;
    const loadingElH = 64; // ローディングアイコン分の高さ
    const diff = maxScroll - elH;

    if (diff - scrollTopVal < loadingElH && fetchCount0 < allCustomer.length / 10 - 1) {
      setIsLoadingActive(true);
      if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = setTimeout(() => {
        setFetchCount0(fetchCount0 + 1);
        setIsLoadingActive(false);
      }, 550);
    }
  };

  // コンテンツのスクロール量を検知し、下スクロールで更新カウントを取得 (閲覧履歴タブ)
  const browsedTabHandleScroll = () => {
    const elH = element.current.clientHeight;
    const maxScroll = element.current.scrollHeight;
    const scrollTopVal = element.current.scrollTop;
    const loadingElH = 64; // ローディングアイコン分の高さ
    const diff = maxScroll - elH;

    if (diff - scrollTopVal < loadingElH) {
      setIsLoadingActive(true);
      if (browsedScrollTimeoutRef.current) clearTimeout(browsedScrollTimeoutRef.current);
      browsedScrollTimeoutRef.current = setTimeout(() => {
        setFetchCount1(fetchCount1 + 1);
        setIsLoadingActive(false);
      }, 550);
    }
  };

  // customerBrowsedArrに格納するときに、必要なデータが入っていないデータをはじくための関数
  const dataFilterForCustomersBrowsedArr = (dataArr) => {
    // ユーザー名、顧客名, customerId, effectAtが入っているかチェック
    // 入っていれば、customersBrowsedArrに格納される
    return dataArr.filter(item => {
      if (!item.customerId) return false;
      if (!item.customerLastName || !item.customerFirstName) return false;
      if (!item.userFirstName || !item.userLastName) return false;
      if (!item.effectAt) return false;
      return item;
    });
  };

  // 連打防止用フラグ
  const isClickingCustomerRef = useRef(false);

  const handleClickCustomer = (id) => {
    // 連打防止: 処理中の場合は無視する
    if (isClickingCustomerRef.current) return;
    isClickingCustomerRef.current = true;
    setTimeout(() => { isClickingCustomerRef.current = false; }, 500);

    onClose2();
    if (selectCustomer.length > 0) {
      if (selectCustomer[0].customerId === id) {
        functions.getCustomerFunctionSp([{ customerId: id }], 1);
      }
    }
    setSelectCustomer([{
      customerId: id,
    }]);
  };

  // 顧客リストを更新(ユーザーIDと組織IDが設定されていれば、反響ツリーから該当する顧客を絞り込み)
  // 実際にUserやDivisionを選択した時に表示する顧客は下記の関数で動く
  useEffect(() => {
    let obj;
    if (selectDefaultUser.userId) {
      obj = getUserFromCustomerTree(
        divisionsGetResponseTree,
        selectDefaultUser.userId,
        selectDefaultDivision.divId,
      );
    } else if (selectDefaultDivision.divId) {
      obj = getDivisionFromCustomerTree(
        divisionsGetResponseTree,
        selectDefaultDivision.divId,
      );
    }
    if (obj) {
      const customerList = getListFromAllCustomer(obj);
      if (customerList) {
        // displayOrderCodeが未設定の場合は初期値の0（反響日の新しい順）でソートする
        const orderCode = 'displayOrderCode' in searchHeader
          ? String(searchHeader.displayOrderCode)
          : '0';
        setAllCustomer(sortCustomerList(orderCode, customerList));
      }
    }
  }, [selectDefaultUser, selectDefaultDivision]);

  useEffect(() => {
    if (customersBrowsed.customerGetBrowsingHistory.customers && customersBrowsed.customerGetBrowsingHistory.customers.length > 0) {
      if (fetchCount1 === 0) setCustomersBrowsedArr({ customers: [...customersBrowsed.customerGetBrowsingHistory.customers] });
      if (fetchCount1 > 0) {
        setCustomersBrowsedArr((prevState) => {
          return { customers: [...prevState.customers, ...dataFilterForCustomersBrowsedArr(customersBrowsed.customerGetBrowsingHistory.customers)] };
          // return { customers: [...prevState.customers, ...customersBrowsed.customerGetBrowsingHistory.customers.filter(item => item.effectAt)] };
        });
        console.log({
          dataFiltered: dataFilterForCustomersBrowsedArr(customersBrowsed.customerGetBrowsingHistory.customers),
          customersBrowsed,
        });
      }
    }
  }, [customersBrowsed]);

  useEffect(() => {
    if (tabSwitch === 1 && fetchCount1 > 0) {
      console.log({ offset: (fetchCount1) * 10, fetchCount1 });
      getBrowsingHistoryFunction({ limit: 10, offset: (fetchCount1) * 10 }); // customer015 10件取得
    }
  }, [fetchCount1]);

  useEffect(() => {
    return () => {
      if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);
      if (browsedScrollTimeoutRef.current) clearTimeout(browsedScrollTimeoutRef.current);
    };
  }, []);

  // useEffect
  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      // only SP ロード時に顧客閲覧履歴を取得 10件
      getBrowsingHistoryFunction({
        limit: 10,
        offset: 0,
      });
      // ここで反響ツリーにcurrentUserIdを入れ込む。defaultUserIdもsetしてあげる。
      // その後setSelectCustomerでSetする
      const { responseHeader } = store.getState();
      const resData = await functions.getCustomerTreeResponseFunction({
        currentUserId: responseHeader?.userId,
        displayOrderCode: 0,
      }, true, queryCustomerId);
      if (!isMounted) return;
      dispatch(updateObjSearchItems({
        currentUserId: responseHeader?.userId,
        currentUser: responseHeader?.userName,
      }));
      const customers = getListFromAllCustomer(resData);
      if (customers) setAllCustomer(customers);
      // 顧客情報を開く
      if (queryCustomerId) {
        handleClickCustomer(queryCustomerId);
      }
      // 初期値を設定
      setSearchHeader({
        currentUserId: responseHeader?.userId,
        displayOrderCode: 0,
      });
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  // 簡易検索条件の変更
  useEffect(() => {
    if (!initSearchHeader) {
      return;
    }
    console.log('更新する');
    console.log({ searchHeader });
    // TODO: 変更時はこのEffectに走る
    // await getCustomerTreeResponseFunction(searchHeader);
  }, [initSearchHeader, searchHeader]);

  // 初期値設定
  useEffect(() => {
    setSearchHeader({
      ...searchHeader,
      displayOrderCode: 0,
    });
    setInitSearchHeader(true);
  }, []);

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar}>
        <Tabs value={tabSwitch} onChange={handleChange} className={classes.tabs}>
          {menusKeys.map((data, index) => (
            <Tab key={data} label={mainHeadMenuTabsList.menus[data]} {...a11yProps(index)} />
          ))}
        </Tabs>
      </AppBar>
      <TabPanel
        className={classes.tabPanel}
        value={tabSwitch}
        index={0}
      >
        <UserListSelectBoxSp
          initLoginData={initLoginData}
          selectUser={selectDefaultUser}
          setSelectUser={setSelectDefaultUser}
          selectDivision={selectDefaultDivision}
          setSelectDivision={setSelectDefaultDivision}
          selectCustomer={selectCustomer}
          setSelectCustomer={setSelectCustomer}
          searchHeader={searchHeader}
          setSearchHeader={setSearchHeader}
          handleClearFunction={handleClearFunction}
          allCustomer={allCustomer}
          setAllCustomer={setAllCustomer}
        />
        <Grid className={classes.scrollRoot} ref={element} onScroll={handleScroll}>
          <PullRefComponent
            refreshing={refreshing}
            onRefresh={handleRefresh}
          >
            <List className={classes.list}>
              {allCustomer.length > 0 ? (
                allCustomer
                  .filter((customer) => 'isHide' in customer === false)
                  .slice(0, fetchCount0 * 10 + 10)
                  .map((data) => {
                    return (
                      <ItemWrap
                        type="all"
                        key={data.customerId}
                        user={data}
                        onClick={() => {
                          handleClickCustomer(data.customerId);
                        }}
                      />
                    );
                  })
              ) : (
                <Typography className={classes.noData}>該当する顧客は存在しませんでした</Typography>
              )}
            </List>
            {/* ローディング用アイコン */}
            { isLoadingActive && <LoadingEllipsis /> }
          </PullRefComponent>
        </Grid>
        {/* 詳細検索画面 */}
        <DetailSearch
          simpleSearch={searchHeader}
          setAllCustomer={setAllCustomer}
        />
        <Drawer
          anchor="right"
          open={open2}
          onClose={() => { setOpen2(true); }}
          className={`${classes.drawer} ${common.onlySp}`}
        >
          <Close
            className={classes.close}
            onClick={() => { setOpen2(false); }}
          />
          <Grid className={`${classes.title} ${classes.headline}`}>
            <Typography className={`${common.title2}`}>検索</Typography>
          </Grid>
          <Grid container className={`${classes.subGrid}`}>
            {/* 検索用componentの入れ込み */}
          </Grid>
        </Drawer>
      </TabPanel>
      <TabPanel className={classes.tabPanel} value={tabSwitch} index={1}>
        <Grid className={classes.scrollRoot} ref={element} onScroll={browsedTabHandleScroll}>
          <PullRefComponent
            refreshing={refreshing}
            onRefresh={handleRefresh}
            canFetchMore
          >
            <List className={classes.list}>
              {customersBrowsedArr.customers && customersBrowsedArr.customers.length > 0
                ? customersBrowsedArr.customers.map((user, i) => (
                  <ItemWrap
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${user.customerId}-index${i}`}
                    user={user}
                    onClick={() => { handleClickCustomer(user.customerId); }}
                  />))
                : (<Typography className={classes.noData}>閲覧済の顧客は存在しませんでした</Typography>
                )}
            </List>
            {/* ローディング用アイコン */}
            { isLoadingActive && <LoadingEllipsis /> }
          </PullRefComponent>
        </Grid>
      </TabPanel>
    </div>
  );
}
